// Vue
import { Vue, Component, Prop, Inject } from "vue-property-decorator";

// Template
import template from "./template.vue";
import { getTranslatedImage as getTranslatedImageHelper } from "#/common/ModuleHelpers";
import { ImageAspectRatio } from "#/components/image_aspect_ratio/ImageAspectRatio";

@Component({
  mixins: [template],
  components: {
    ImageAspectRatio,
  },
})
export class GalleryItem extends Vue {
  @Prop()
  public item!: object;

  @Prop()
  public lang!: string;

  public getTranslatedImage(imageObject, language, size) {
    return getTranslatedImageHelper(imageObject, language, size);
  }

  get isVideo() {
    return (
      this.item["video"] &&
      this.item["video"] != "" &&
      (this.item["video"]["embedUrl"] || this.item["video"]["uploadUrl"])
    );
  }

  public bgStyle(lang, size) {
    return {
      "background-image":
        'url("' +
        this.getTranslatedImage(this.item["image"], lang, size) +
        '")',
    };
  }
}
